import {InjectionToken} from "@angular/core";
import {MONTH_IN_YEAR} from "../constants";

export const INT_MONTH_IN_YEAR_TOKEN = new InjectionToken<number>('INT_MONTH_IN_YEAR_TOKEN', {
  factory() {
    return MONTH_IN_YEAR;
  }
})
